import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

	@Input()
	message: string;
	defaultMessage = 'Loading';

	@Input()
	diameter: number;
	defaultDiameter = 50;

	constructor() { }

}
